const NS = 'AlphaSortFilter';

export default function AlphaSortFilter() {

  return function (array, sortOn) {

    function sortAlphaNum(a, b) {
      if (sortOn) {
        a = a[sortOn];
        b = b[sortOn];
      }

      return a.toString().localeCompare(b.toString(), undefined, { numeric: true });
    }

    return array.sort(sortAlphaNum);
  };
}
